import React, { useState, useEffect, useCallback } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  TablePagination,
  TableSortLabel,
  IconButton,
  Dialog,
  Box,
  Button,
  Stack,
  CircularProgress,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Switch,
  Collapse,
  Typography,
  Grid,
  Autocomplete,
  TextField,
} from "@mui/material";
import {
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";
import { DELETE, GET, POST, PUT } from "../../api/ApiService";
import EncryptionHelper from "../../shared/EncryptionHelper/index";
import { toast } from "react-toastify";
import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";
import PreviewIcon from "@mui/icons-material/Preview";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../shared/SearchBar";
import { useDispatch, useSelector } from "react-redux";
import ButtonCommon from "../../shared/ButtonCommon";
// import { storeCaseDetails } from "../../slices/caseDetailSlice";
import { storeEditCase } from "../../slices/editCaseSlice";
import SortIcon from "@mui/icons-material/Sort";
import SelectInput from "../../shared/SelectInput";
// import AssignedToFilter from "../../shared/AssignedToFilter";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { courtDropdown } from "../AddEditConstants";
import { saveAs } from "file-saver";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { serviceTypeData } from "../../constants/ServiceTypeDropdown";

const headerConfig = [
  { id: "actions", label: "Actions", sortable: false },
  { id: "CaseName", label: "Case Name", sortable: true },
  { id: "CaseNumber", label: "Case Number", sortable: true },
  { id: "DocketIndexNumber", label: "Docket Number", sortable: true },
  { id: "VoucherNumber", label: "Voucher Number", sortable: true },
  { id: "AssignedToUser", label: "Assigned to", sortable: true },
  { id: "Status", label: "Status", sortable: true },
  { id: "CaseType", label: "CaseType", sortable: true },
  { id: "ReceivedDate", label: "Received Date", sortable: true },
  { id: "Court", label: "Court", sortable: true },
  { id: "Judge", label: "Judge", sortable: true },
  { id: "AdjournedDate", label: "Adjourned Date", sortable: true },
  { id: "Billed", label: "Billed", sortable: true },
  { id: "CreatedAt", label: "Created At", sortable: true },
  { id: "UpdatedAt", label: "Updated At", sortable: true },
  { id: "ModifiedByUser", label: "ModifiedByUser", sortable: true },
  { id: "ServiceType", label: "ServiceType", sortable: true },
  { id: "ReportContactInfo", label: "ReportContactInfo", sortable: true },
  { id: "Comments", label: "Comments", sortable: true },
];

const filterColumnData = [
  {
    value: "Assigned To",
    label: "Assigned To",
  },
  {
    value: "Court",
    label: "Court",
  },
  {
    value: "Judge",
    label: "Judge",
  },
  {
    value: "Service Type",
    label: "Service Type",
  },
];

const sortingData = [
  {
    label: "Case Name",
    value: "CaseName",
  },
  {
    label: "Case Type",
    value: "CaseType",
  },
  {
    label: "Created Date",
    value: "CreatedAt",
  },
  {
    label: "Updated Date",
    value: "UpdatedAt",
  },
  {
    label: "Received Date",
    value: "ReceivedDate",
  },
  {
    label: "Adjourned Date",
    value: "AdjournedDate",
  },
];

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    // if (page > 1) {
    onPageChange(event, page - 1);
    // }
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div style={{ flexShrink: 0, marginLeft: "2.5rem" }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPage />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPage />
      </IconButton>
    </div>
  );
}

function CasePageTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(75);
  const [totalRows, setTotalRows] = useState(0);
  const [openComment, setOpenComment] = useState(false);
  const [comntData, setComntData] = useState("");
  const [loading, setLoading] = useState(true);
  const [sortData, setSortData] = useState("CreatedAt");
  const [sortOrder, setSortOrder] = useState("ASC");
  const [search, setSearch] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [openAssignedto, setOpenAssignedto] = useState(false);
  const [assignedtoData, setAssignedtoData] = useState([]);
  const [assignedToFilter, setAssignedToFilter] = useState([]);
  const [filterCol, setFilterCol] = useState();
  const [courtfilter, setCourtFilter] = useState([]);
  const [judgeFilter, setJudgeFilter] = useState([]);
  const [serviceTypeFilter, setServiceTypeFilter] = useState([]);
  const [judgesData, setJudgesData] = useState();
  const [judgeSearchInput, setJudgeSearchInput] = useState("");
  const [judgeLoading, setJudgeLoading] = useState(false);
  const [showSaveCol, setShowSaveCol] = useState(false);
  const [columns, setColumns] = useState(headerConfig);
  const [radioChecked, setRadioChecked] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  useEffect(() => {
    GET("users")
      .then((resp) => {
        const encryptedData = resp?.encryptedData;
        const decryptedData = EncryptionHelper.decryptData(encryptedData);

        setAssignedtoData(decryptedData?.users);
      })
      .catch((err) => {
        console.warn("error =>", err);
      });

    getUserPreference();

    // getJudgeList();
  }, []);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 5 },
    }),
  );

  // Sortable header cell
  const SortableHeaderCell = ({ header }) => {
    const { attributes, listeners, setNodeRef, transform, transition } =
      useSortable({ id: header.id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      cursor: "grab",
    };

    useEffect(() => {
      const fetchJudges = async () => {
        try {
          setJudgeLoading(true);
          const response = await GET(
            `contact/fetchJudges?search=${judgeSearchInput}`,
          );
          const formattedData = response.data?.map((item) => ({
            label: item.Name,
            value: item.Name,
          }));
          setJudgesData(formattedData);
        } catch (err) {
          toast.error(err?.response?.data?.message || "Failed to fetch judges");
        } finally {
          setJudgeLoading(false);
        }
      };

      if (judgeSearchInput.trim().length >= 1) {
        const delayDebounce = setTimeout(() => {
          fetchJudges();
        }, 500); // ✅ wait 500ms

        return () => clearTimeout(delayDebounce);
      } else {
        // reset list if input is cleared
        setJudgesData([]);
      }
    }, [judgeSearchInput]);

    return (
      <TableCell
        ref={setNodeRef}
        {...attributes}
        {...listeners}
        style={style}
        key={header.id}
      >
        {header.sortable ? (
          <TableSortLabel
            active={orderBy === header.id}
            direction={orderBy === header.id ? order : "asc"}
            onClick={() => handleRequestSort(header.id)}
          >
            {header.label}
          </TableSortLabel>
        ) : (
          header.label
        )}
      </TableCell>
    );
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = columns.findIndex((col) => col.id === active.id);
      const newIndex = columns.findIndex((col) => col.id === over.id);
      setColumns((items) => arrayMove(items, oldIndex, newIndex));
      setShowSaveCol(true);
    }
  };

  const userDetails = useSelector((state) => state.userReducer.userDetails);

  const permissionsIdArray = userDetails?.permission?.map((item) => {
    return item.permission_id;
  });

  useEffect(() => {
    if (sortData || sortOrder) {
      fetchData();
    }
  }, [sortData, sortOrder, page, rowsPerPage]);

  const getUserPreference = async () => {
    try {
      const resp = await GET(
        `user-column-preference/get-order?userId=${userDetails?.id}&pageReference=cases`,
      );

      if (resp) {
        setSortData(resp?.sortBy || "ReceivedDate");
        setSortOrder(resp?.sortOrder || "DESC");
        setColumns(resp?.columnOrder ?? headerConfig);
        setRadioChecked(resp?.sortOrder === "DESC" ? true : false);
      }
    } catch (err) {
      toast.error("Error in getting column order");
      console.warn(err);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const judgeFilterValues = judgeFilter.map((item) => item.value);

    GET(
      `case/get-cases?pageNumber=${
        page + 1
      }&pageSize=${rowsPerPage}&status=${"Open"}&search=${search}&sortBy=${
        sortData || "CreatedAt"
      }&order=${sortOrder || "ASC"}&assignedToUserIDs=${assignedToFilter.join(
        ",",
      )}&judgeFilter=${encodeURIComponent(
        JSON.stringify(judgeFilterValues),
      )}&courtfilter=${courtfilter.join(
        ",",
      )}&serviceTypeIDs=${serviceTypeFilter.join(",")}`,
    )
      .then((response) => {
        const encryptedData = response?.encryptedData;
        const decryptedData = EncryptionHelper.decryptData(encryptedData);
        console.log("decryptedData =>", decryptedData);
        setData(decryptedData?.cases);
        setTotalRows(decryptedData?.totalData);
        setLoading(false);
        // setOpenFilter(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setLoading(false);
      });
  };

  // const getJudgeList = async () => {
  //   try {
  //     const response = await GET("contact/fetchJudges");

  //     const formattedData = response.data?.map((item) => {
  //       return {
  //         value: item.Name,
  //         label: item.Name,
  //       };
  //     });

  //     setJudgesData(formattedData);
  //   } catch (err) {
  //     console.error("Error fetching judges:", err?.response?.data);
  //     toast.error(err?.response?.data?.message);
  //   }
  // };

  const handleSelectAllClick = (event) => {
    /*
    if (event.target.checked) {
      const newSelected = data.map((n) => n.CaseID);
      setSelected(newSelected);
    } else {
      setSelected([]);
    }
    */
  };

  const handleClick = (event, id) => {
    event.stopPropagation();
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const isDateField = (field) => {
    return ["ReceivedDate", "AdjournedDate", "CreatedAt", "UpdatedAt"].includes(
      field,
    );
  };

  const sortedData = data.slice().sort((a, b) => {
    if (orderBy) {
      const valueA = a[orderBy] || "";
      const valueB = b[orderBy] || "";

      if (isDateField(orderBy)) {
        const dateA =
          valueA === "null" || valueA === "Invalid date"
            ? null
            : new Date(valueA);
        const dateB =
          valueB === "null" || valueB === "Invalid date"
            ? null
            : new Date(valueB);

        // Handle null values: place them at the end for ascending order and at the start for descending order
        if (dateA === null && dateB === null) return 0;
        if (dateA === null) return order === "asc" ? 1 : -1;
        if (dateB === null) return order === "asc" ? -1 : 1;

        // Handle Invalid dates
        if (isNaN(dateA) && isNaN(dateB)) return 0; // Both are invalid dates
        if (isNaN(dateA)) return order === "asc" ? 1 : -1; // dateA is invalid
        if (isNaN(dateB)) return order === "asc" ? -1 : 1; // dateB is invalid

        return order === "asc" ? dateA - dateB : dateB - dateA;
      } else {
        return order === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }
    }
    return 0;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCloseComment = () => {
    setOpenComment(false);
  };

  // Debounce function
  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  }

  // Debounced search function using useCallback
  const getSearchValue = useCallback(
    debounce(async (value) => {
      setLoading(true);
      const judgeFilterValues = judgeFilter.map((item) => item.value);

      setSearch(value);
      try {
        const response = await GET(
          `case/get-cases?pageNumber=${1}&pageSize=${rowsPerPage}&status=${"Open"}&search=${value}&casetype=${""}&ReadyToAssign=${""}&sortBy=${
            sortData || "CreatedAt"
          }&order=${
            sortOrder || "ASC"
          }&assignedToUserIDs=${assignedToFilter.join(
            ",",
          )}&judgeFilter=${encodeURIComponent(
            JSON.stringify(judgeFilterValues),
          )}&courtfilter=${courtfilter.join(",")}`,
        );
        const encryptedData = response?.encryptedData;
        const decryptedData = EncryptionHelper.decryptData(encryptedData);
        console.log("decryptedData =>", decryptedData);
        setData(decryptedData?.cases);
        setTotalRows(decryptedData?.totalData);
        setPage(0);
      } catch (err) {
        console.warn(err);
      } finally {
        setLoading(false);
      }
    }, 1000),
    [rowsPerPage, sortData, sortOrder, assignedToFilter],
  );

  const deleteBtnHandler = () => {
    const deleteData = {
      ids: selected,
    };

    console.log("data to be encrypted =>", deleteData);

    const encryptData = EncryptionHelper.encryptData(deleteData);

    DELETE(`case/delete-case`, { encryptData })
      .then((resp) => {
        toast.success(resp?.message);
        // setToggleClearRows(!toggledClearRows);
        fetchData();
        setSelected([]);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const handleRadioClicked = async (e) => {
    try {
      const payload = {
        userId: userDetails?.id,
        pageReference: "cases",
        sortData: e.target.value,
      };

      const encryptData = EncryptionHelper.encryptData(payload);

      const resp = await PUT("user-column-preference/set-sorting-data", {
        encryptData,
      });
      setSortData(e.target.value);
    } catch (err) {
      toast.error("error occured");
    }
  };

  const switchHandler = async (e) => {
    try {
      const payload = {
        userId: userDetails?.id,
        pageReference: "cases",
        sortOrder: e.target.checked ? "DESC" : "ASC",
      };

      const encryptData = EncryptionHelper.encryptData(payload);

      if (e.target.checked) {
        setSortOrder("DESC");
        setRadioChecked(true);
      } else {
        setSortOrder("ASC");
        setRadioChecked(false);
      }

      const resp = await PUT("user-column-preference/set-sorting-order", {
        encryptData,
      });
    } catch (err) {
      toast.error("error");
    }
  };

  const openFilterHandler = () => {
    setOpenFilter(!openFilter);
  };

  const openAssignedTofilter = () => {
    setOpenAssignedto(!openAssignedto);
  };

  const filterBtnHandler = () => {
    fetchData();
  };

  const clearFilterBtnHandler = () => {
    setLoading(true);
    GET(
      `case/get-cases?pageNumber=${
        page + 1
      }&pageSize=${rowsPerPage}&status=${"Open"}&search=${search}&sortBy=${sortData}&order=${sortOrder}`,
    )
      .then((response) => {
        const encryptedData = response?.encryptedData;
        const decryptedData = EncryptionHelper.decryptData(encryptedData);
        console.log("decryptedData =>", decryptedData);
        setData(decryptedData?.cases);
        setTotalRows(decryptedData?.totalData);
        setCourtFilter([]);
        setJudgeFilter([]);
        setAssignedToFilter([]);
        setServiceTypeFilter([]);
        setLoading(false);
        setOpenFilter(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setLoading(false);
      });
  };

  const saveColumnOrderHandler = async () => {
    const postData = {
      userId: userDetails?.id,
      columnOrder: columns,
      pageReference: "cases",
    };

    console.log("data to be encrypted ====>", postData);

    const encryptData = EncryptionHelper.encryptData(postData);

    try {
      const resp = await POST("user-column-preference/set-column-preference", {
        encryptData,
      });
      toast.success(resp?.message);
      setShowSaveCol(false);
    } catch (err) {
      toast.error("err of save column handler");
      console.warn("err of save column handler----", err);
    }
  };

  const exportCsv = async () => {
    try {
      setExportLoading(true);
      const result = await GET(
        `case/export-closed-cases?status=${"Open"}&sortBy=${sortData}&order=${sortOrder}`,
      );

      const caseList = result?.data || [];

      if (!caseList.length) {
        setExportLoading(false);
        toast.error("No data available to export.");
        return;
      }

      // Exclude 'actions' column
      const filteredHeaderConfig = headerConfig.filter(
        (h) => h.id !== "actions",
      );

      // Create CSV header
      const headers = filteredHeaderConfig.map((h) => h.label).join(",");

      // Create CSV rows
      const rows = caseList.map((row) =>
        filteredHeaderConfig
          .map((h) => {
            const value = row[h.id] ?? "";
            const escaped = String(value).replace(/"/g, '""');
            return `"${escaped}"`;
          })
          .join(","),
      );

      // Final CSV content
      const csvContent = [headers, ...rows].join("\n");

      // Create a Blob and download it
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, `cases_export_${new Date().toISOString()}.csv`);

      setExportLoading(false);
    } catch (error) {
      console.error("Error exporting CSV:", error);
      setExportLoading(false);
    }
  };

  return (
    <div>
      <Stack
        direction="row"
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        gap={2}
        mb={2}
      >
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"flex-end"}
          gap={2}
        >
          {permissionsIdArray?.includes(20) && (
            <ButtonCommon
              btnClicked={() => {
                navigate("/addcase");
              }}
            >
              Add new item
            </ButtonCommon>
          )}

          {selected?.length > 0 && (
            <Button
              variant="contained"
              color="red"
              sx={{
                color: "white",
              }}
              onClick={deleteBtnHandler}
            >
              Delete
            </Button>
          )}
          {showSaveCol && (
            <ButtonCommon btnClicked={saveColumnOrderHandler}>
              Save View
            </ButtonCommon>
          )}
        </Stack>

        <Stack
          sx={{ width: "30%", minWidth: "240px" }} // added for mobile view
          flexDirection={"row"}
          gap={2}
        >
          <Stack>
            <ButtonCommon btnClicked={exportCsv} disabled={exportLoading}>
              Export
            </ButtonCommon>
          </Stack>
          <FilterAltIcon
            onClick={openAssignedTofilter}
            fontSize="large"
            sx={{ cursor: "pointer" }}
          />

          <SortIcon
            onClick={openFilterHandler}
            fontSize="large"
            sx={{ cursor: "pointer" }}
          />

          <SearchBar
            searchHeight={"40px"}
            placeholder={"Search for case"}
            searchValue={getSearchValue}
          />
        </Stack>
      </Stack>

      <Collapse in={openFilter}>
        <Stack
          flexDirection={"row"}
          alignItems={"flex-end"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
          m={2}
        >
          {sortData && (
            <FormControl>
              {/* <FormLabel>Sort by</FormLabel> */}
              <RadioGroup row value={sortData} onChange={handleRadioClicked}>
                {sortingData?.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    value={item.value}
                    control={<Radio />}
                    label={item.label}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          )}
          <Stack
            alignItems={"center"}
            flexDirection={"row"}
            justifyContent={"center"}
            p={0.5}
          >
            Ascending
            <Switch
              size="small"
              checked={radioChecked}
              onChange={switchHandler}
            />
            Descending
          </Stack>
        </Stack>
      </Collapse>

      {/* Filter column /> */}
      <Collapse in={openAssignedto}>
        <Typography sx={{ textAlign: "left" }}>Filter Column</Typography>
        <Stack direction={"row"} gap={2} sx={{ width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <SelectInput
                name="filterColumn"
                placeholder=""
                onChangeValue={(e) => {
                  setFilterCol(e?.target?.value);
                }}
                value={filterCol}
                dropDownData={filterColumnData}
              />
            </Grid>

            <Grid item xs={4}>
              {filterCol === "Assigned To" && (
                <SelectInput
                  name="assignedTofilter"
                  placeholder="Select Assigned to"
                  onChangeValue={(e) => {
                    setAssignedToFilter(e?.target?.value);
                    setCourtFilter([]);
                    setJudgeFilter([]);
                  }}
                  value={assignedToFilter}
                  dropDownData={assignedtoData?.map((item) => {
                    return {
                      value: item.UserID,
                      label: item.Username,
                    };
                  })}
                  helperText=""
                  isMulti={true}
                />
              )}
              {filterCol === "Court" && (
                <SelectInput
                  name="court"
                  placeholder="Select Court"
                  onChangeValue={(e) => {
                    setCourtFilter(e.target.value);
                    setAssignedToFilter([]);
                    setJudgeFilter([]);
                  }}
                  value={courtfilter}
                  dropDownData={courtDropdown}
                  showPleaseSelect={false}
                  isMulti={true}
                  helperText=""
                />
              )}
              {filterCol === "Judge" && (
                <Autocomplete
                  multiple
                  size="small"
                  filterSelectedOptions
                  options={judgesData || []} // [{label, value}]
                  value={judgeFilter}
                  inputValue={judgeSearchInput}
                  onInputChange={(event, newInputValue) => {
                    setJudgeSearchInput(newInputValue);
                  }}
                  onChange={(event, newValue) => {
                    setJudgeFilter(newValue);
                    setAssignedToFilter([]);
                    setCourtFilter([]);
                  }}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  loadingText="Loading..."
                  noOptionsText="No Judges Found"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search Judge"
                      placeholder="Type to search judge..."
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {judgeLoading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              )}
              {filterCol === "Service Type" && (
                <SelectInput
                  name="serviceTypeFilter"
                  placeholder="Select Service Type"
                  onChangeValue={(e) => {
                    setServiceTypeFilter(e?.target?.value);
                    setAssignedToFilter([]);
                    setCourtFilter([]);
                    setJudgeFilter([]);
                  }}
                  value={serviceTypeFilter}
                  dropDownData={serviceTypeData}
                  helperText=""
                  isMulti={true}
                />
              )}
            </Grid>
          </Grid>
          {courtfilter.length ||
          judgeFilter.length ||
          assignedToFilter.length ||
          serviceTypeFilter?.length ? (
            <ButtonCommon btnClicked={clearFilterBtnHandler}>
              Clear
            </ButtonCommon>
          ) : (
            ""
          )}

          <ButtonCommon btnClicked={filterBtnHandler}>Filter</ButtonCommon>
        </Stack>
      </Collapse>

      {loading ? (
        <Stack justifyContent={"center"} alignItems={"center"} height={400}>
          <CircularProgress />
        </Stack>
      ) : (
        <>
          {sortedData?.length > 0 ? (
            <>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          indeterminate={
                            selected.length > 0 && selected.length < data.length
                          }
                          checked={
                            data.length > 0 && selected.length === data.length
                          }
                          onChange={handleSelectAllClick}
                        />
                      </TableCell>

                      <DndContext
                        collisionDetection={closestCenter}
                        onDragEnd={handleDragEnd}
                        sensors={sensors}
                      >
                        <SortableContext
                          items={columns.map((c) => c.id)}
                          strategy={horizontalListSortingStrategy}
                        >
                          {columns.map((header) => (
                            <SortableHeaderCell
                              key={header.id}
                              header={header}
                            />
                          ))}
                        </SortableContext>
                      </DndContext>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {sortedData.map((row) => {
                      const isItemSelected =
                        selected.indexOf(row.CaseID) !== -1;
                      return (
                        <TableRow
                          key={row.CaseID}
                          role="checkbox"
                          selected={isItemSelected}
                          onClick={(event) => {
                            event.stopPropagation();
                          }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) =>
                                handleClick(event, row.CaseID)
                              }
                              onClick={(event) => event.stopPropagation()}
                            />
                          </TableCell>

                          {columns.map((header) => {
                            const columnId = header.id;

                            if (columnId === "actions") {
                              return (
                                <TableCell key={columnId}>
                                  <EditIcon
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => {
                                      dispatch(storeEditCase(row));
                                      navigate("/editcase");
                                    }}
                                  />
                                </TableCell>
                              );
                            }

                            if (columnId === "CaseName") {
                              return (
                                <TableCell
                                  key={columnId}
                                  onClick={() => {
                                    dispatch(storeEditCase(row));
                                    window.open(
                                      `/#/casedetails?CID=${row.CaseID}`,
                                      "_blank",
                                    );
                                  }}
                                  sx={{ cursor: "pointer", color: "#01997D" }}
                                >
                                  {row[columnId]}
                                </TableCell>
                              );
                            }

                            if (
                              ["ReceivedDate", "AdjournedDate"].includes(
                                columnId,
                              )
                            ) {
                              return (
                                <TableCell key={columnId}>
                                  {row[columnId]
                                    ? moment(row[columnId]).format("LL")
                                    : "null"}
                                </TableCell>
                              );
                            }

                            if (["CreatedAt", "UpdatedAt"].includes(columnId)) {
                              return (
                                <TableCell key={columnId}>
                                  {row[columnId]
                                    ? moment
                                        .utc(row[columnId])
                                        .local()
                                        .format("LLL")
                                    : "null"}
                                </TableCell>
                              );
                            }

                            if (columnId === "Billed") {
                              return (
                                <TableCell key={columnId}>
                                  {row.Billed === 1 ? "Yes" : "No"}
                                </TableCell>
                              );
                            }

                            if (columnId === "Comments") {
                              return (
                                <TableCell key={columnId}>
                                  {row.Comments && (
                                    <PreviewIcon
                                      onClick={() => {
                                        setOpenComment(true);
                                        setComntData(row.Comments);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    />
                                  )}
                                </TableCell>
                              );
                            }
                            // if (columnId === "Custodial_Attorney_Contact") {
                            //   return (
                            //     <TableCell key={columnId}>
                            //       {row.Custodial_Attorney_Contact}
                            //     </TableCell>
                            //   );
                            // }
                            // if (columnId === "Visiting_Attorney_Contact") {
                            //   return (
                            //     <TableCell key={columnId}>
                            //       {row.Visiting_Attorney_Contact}
                            //     </TableCell>
                            //   );
                            // }
                            // if (columnId === "Child_Attorney_Contact") {
                            //   return (
                            //     <TableCell key={columnId}>
                            //       {row.Child_Attorney_Contact}
                            //     </TableCell>
                            //   );
                            // }

                            return (
                              <TableCell key={columnId}>
                                {row[columnId]}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 50, 75, 700]}
                component="div"
                count={totalRows}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </>
          ) : (
            <Stack justifyContent={"center"} alignItems={"center"} height={200}>
              No cases found
            </Stack>
          )}
        </>
      )}
      <Dialog open={openComment} onClose={handleCloseComment}>
        <Box p={4}>
          <div dangerouslySetInnerHTML={{ __html: comntData }}></div>
        </Box>
      </Dialog>
    </div>
  );
}

export default CasePageTable;
